import { left, right } from 'fp-ts/Either';
import { httpClientFunction } from 'domain/types';
import ReadMarketAppsClient from 'use-case/marketApps/read/readMarketAppsClient';
import { MarketAppView } from 'domain/entity/market/marketApp';
import ReadMarketAppsCriteria from 'use-case/marketApps/read/readMarketAppsCriteria';

export default (httpClient: httpClientFunction, baseUrl: string): ReadMarketAppsClient => (criteria: ReadMarketAppsCriteria) =>
    httpClient(`${baseUrl}/apps-market/apps?visibility=${criteria.visibility}&installed=true`, {})
        .then((response) =>
            response.ok
                ? response
                      .json()
                      .then(asMarketApps)
                      .then(right)
                      .catch(() => left({ error: new Error(), status: 500 }))
                : left({ error: new Error(), status: response.status })
        )
        .catch(() => left({ error: new Error(), status: 503 }));

const asMarketApps = (marketAppJson: MarketAppJson): MarketAppView[] =>
    marketAppJson.flatMap((marketApp) =>
        marketApp.views.map((view: MarketAppViewJson) => new MarketAppView(view.id, view.key, view.title))
    );

type MarketAppJson = {
    views: MarketAppViewJson[];
}[];

type MarketAppViewJson = {
    id: number;
    resourceKey: string;
    title: string;
    url: string;
    visibility: string;
    key: string;
};
